import { DashboardService } from '../../../../../service/events/dashboard.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import { FertilizantesFormDefinition } from './form-control/form-definition';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ProductosApiService } from '../../../../../service/api/productos-api';
import {
  build,
  pool,
  buildParams,
} from '../../../../../common/classes/request-builder';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { FormRequestTypes } from '../../../../../common/classes/form-request';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { Subject } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { UsuariosApiService } from '../../../../../service/api/usuarios-api.service';

import { TareaFertiModel } from '../../../../../models/tareas/tarea-ferti.model';
import { ParcelasModel } from '../../../../../models/form-common/parcelas.model';
import { SectorModel } from '../../../../../models/form-common/sector.model';
import { ProductosModel } from '../../../../../models/productos/productos.model';
import { MantenimientoModel } from '../../../../../models/trabajadores/mantenimiento.model';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { EventPhase, FormPhase } from 'src/app/common/components/reactive-form-builder/form-request';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { ClienteModel } from 'src/app/models/cliente.model';

@Component({
  selector: 'app-fito-form',
  standalone: false,
  templateUrl: './fertilizantes-form.component.html',
  styleUrls: ['./fertilizantes-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FertilizantesFormComponent
  extends BaseForm<TareaFertiModel>
  implements OnInit, OnDestroy {      
    public loadingData = true;

    public dropdownLoadTrigger = new Subject<void>();
    public dropdownsFinalized = false;

    public form!: FertilizantesFormDefinition;
    
    public formRequest: ReactiveFormBuilderComponent<TareaFertiModel>;

    public getRequest =
      this.getType() === FormRequestTypes.DUPLICATE
        ? this.tareasApi.fertilizantes.GET_GENERIC
        : this.tareasApi.fertilizantes.GET;

    public recalculateEmmiter = new Subject();

    public mostrarPlan = true;

    public errorMessage = '';

    public planProductos: ProductosModel[] = [];

    public planSectores: SectorModel[] = [];

    public showPlanAbonado = false;

    contador = 0;

    public intervaloParcelas: string | number | NodeJS.Timeout | undefined = '';

    disabledDates: Date[] = [];

    /*** Firma DonJardin ***/
    public signatureFile: File = new File([], '');
    
    constructor(
        public fincasApi: FincasApiService,
        public siexApi: SiexApiService,
        public tareasApi: TareasApiService,
        public productosApi: ProductosApiService,
        public trabajadoresApi: TrabajadoresApiService,
        private readonly userApi: UsuariosApiService,
        public override router: Router,
        public override route: ActivatedRoute,
        public dashboardEvents: DashboardService,
        public clientesApi: ClientesApiService,
        private readonly http: HttpClient,
        private readonly cdr: ChangeDetectorRef
    ) {
      super(
        route,
        router,
        dashboardEvents,
        tareasApi.fertilizantes.PUT,
        tareasApi.fertilizantes.POST,
        'fertilizantes',
        'Editar Tarea Fertilizante',
        'Realizar Tarea Fertilizante',
        'Duplicar Tarea Fertilizante'
      );
      this.formRequest = new ReactiveFormBuilderComponent(this.http);
    }

    public async ngOnInit(): Promise<void> {
      this.expandFormRequest();
      this.formRequest.executePhase(FormPhase.LOAD);
      const intervalo = setInterval(() => {

        if (this.form.env.showKilosHectarea) {
          clearInterval(intervalo);
        }
        
        this.contador++;
        if (this.contador >= 1000) {
          clearInterval(intervalo);
        }
      }, 1000);

      this.softInit(this.getType());
      await this.setupFormConFechas();
      this.form.requestType = this.getType();

      if (this.form.env.appName === 'detorres') {
        setTimeout(() => {
          this.form.model.fecha_inicio =
                    this.route.snapshot.queryParamMap.get('date')!;
        }, 1500);
      }
    }

    public async getEventosAPI(): Promise<{
        dates: Date[];
        eventos: {
            start: string;
            title: string;
            hora_inicio: string;
            hora_fin: string;
        }[];
    }> {
      const fechas: Date[] = [];
      let eventosRaw: any[] = [];

      try {
        eventosRaw = await this.tareasApi.eventos.GET.toPromise();
        for (const ev of eventosRaw) {
          const [dd, mm, yyyy] = ev.start.split('-').map(Number);

          if ([dd, mm, yyyy].every(Number.isInteger)) {
            fechas.push(new Date(yyyy, mm - 1, dd));
          }
        }
      } catch (err) {
        console.error('Error cargando eventos:', err);
      }
      return { dates: fechas, eventos: eventosRaw };
    }

    // SUPPORT

    
    formChanges(formModel: [object, string], tag: string) {
        this.form.model = formModel as unknown as TareaFertiModel;
        this.form.tag = tag;

        this.form.lastFieldEdited = tag;

        if (tag === 'numero_dias' || tag === 'dias_semana') {
            this.validate();
        }

        if (tag === 'id_cliente') {
            this.dropdownsFinalized = false;
            pool(
                [
                    buildParams(
                        this.fincasApi.fincasGET,
                        { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel)?.id },
                        this.form.lists.fincas,
                        'nombre',
                        true
                    ),
                    buildParams(
                        this.fincasApi.sectoresGET,
                        { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel)?.id },
                        this.form.lists.sectores,
                        'nombre',
                        true
                    ),
                    buildParams(
                        this.fincasApi.parcelasGET,
                        { id_cliente: (this.form.model.id_cliente as unknown as ClienteModel)?.id },
                        this.form.lists.parcelas,
                        'nombre',
                        true
                    ),
                ],
                () => {
                    this.form.lists.fincas.filtered = this.form.lists.fincas.values;
                    this.form.lists.sectores.filtered = [];
                    this.form.lists.parcelas.values = this.form.lists.parcelas.values.filter(
                        (it) => it.label !== '...'
                    );
                }
            )
                .then(() => {
                    if (this.form.env.appName === 'avafitogest') {
                        this.form.lists.parcelas.values = this.form.lists.parcelas.values
                            .filter(it => it.label !== '...')
                            .map(it => ({
                                ...it,
                                label: this.parcelaLabel(it.value as ParcelasModel)
                            }));
                        this.form.lists.parcelas.filtered = this.form.lists.parcelas.values;
                    }
                    this.formRequest.executePhase(FormPhase.UPDATE);
                      this.dropdownsFinalized = true;
                    return;
                })
                .catch((e) => {
                    console.log('catch en pool: ' + e);
                    this.dropdownsFinalized = true;
                });
        }


        setTimeout(() => {
            this.recalculateEmmiter.next(true);
        }, 5);

      this.form.npkBuilder.lists = this.form.lists;
      this.form.npkBuilder.model = this.form.model;

      this.form.npkBuilder.calculaNPKs();
      this.form.refreshFertilizantesTablesFromNpk();
    }

    public validate() {
        this.errorMessage = '';

        if (this.form.model.dias_semana) {
            if (
                (this.form.lists.weekDays.selected || []).length !==
                parseInt(this.form.model.numero_dias ?? '', 10)
            ) {
                this.errorMessage = 'Días Semana no coincide con Número Días';
            }
        }
    }

    generarInforme() {
      const prod = {} as ProductosModel;
      const sect = {} as SectorModel;

      const prods = [
        this.form.lists.productos.selected,
      ];

      (prods || []).forEach((producto) => {
        if (producto) {
          prod.id = producto.id ?? '';
          prod.nombre = producto.nombre;
          prod.cantidad = +(producto.cantidad ?? 0);
          this.planProductos.push(prod);
        }
      });

      (this.form.lists.sectores.selected || []).forEach((sector: SectorModel) => {
        sect.id = sector.id ?? '';
        sect.nombre = sector.nombre;

        this.planSectores.push(sect);
      });

      this.showPlanAbonado = true;
    }

    public override ngOnDestroy() {
      clearInterval(this.intervaloParcelas);
    }

    formatoHorasMinutos(horaEntrada: string, horaSalida: string) {
      let timeStr: string | string[] = horaEntrada;

      timeStr = timeStr.split(':');

      const h = timeStr[0] ?? '',
        m = timeStr[1] ?? '';

      const newTime = moment(`${horaSalida} 2021-04-05`, 'HH:mm YYYY-MM-DD')
        .subtract({ hours: +h, minutes: +m })
        .format('HH:mm');

      return newTime;
    }

    private initFormData(): Promise<unknown> {
      const buildsRequest = [
        build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', true),
        build(this.fincasApi.sectoresGET, this.form.lists.sectores, 'nombre', true),
        build(
          this.fincasApi.parcelasGET,
          this.form.lists.parcelas,
          this.form.env.appName === 'avafitogest' ? this.parcelaLabel : 'nombre',
          true
        ),
        build(this.siexApi.buenasPracticasFertilizantesGET, this.form.lists.buenasPracticasFertilizantes, 'buenas_practicas_fertilizantes'),
        build(this.siexApi.metodosFertiGET, this.form.lists.metodosAplicacionFertis, 'metodo_de_fertilizacion'),
        build(this.siexApi.tiposFertiGET, this.form.lists.tiposFertilizacionSIEX, 'tipo_de_fertilizacion'),
        build(
          this.trabajadoresApi.trabajadoresGET,
          this.form.lists.trabajadores,
          (it: MantenimientoModel) => it.nombre + ' ' + (it.apellidos || ''),
          true
        ),
        build(this.clientesApi.clientesGET, this.form.lists.clientes, {
          or: ['razon_social', 'nombre'],
        }),
        build(
          this.productosApi.productos.GET,
          this.form.lists.productos,
          'nombre',
          true
        ),
      ];

      if (this.form.env.showAssignUserTasksFitosanitario || this.form.env.showAssignUserInAllTasks) {
        buildsRequest.push(
          build(this.userApi.usuariosGET, this.form.lists.users, 'nombre')
        );
      }

      return pool(buildsRequest, () => {
        this.form.lists.productos.filtered = [...this.form.lists.productos.values];
        
        this.recalculateEmmiter.next(true);

        setTimeout(() => {
          this.form.npkBuilder.calculaNPKs();
          this.formRequest.executePhase(FormPhase.UPDATE);
        }, 200);
      })
        .then(() => {
          this.dropdownLoadTrigger.next();
          this.loadingData = false;
          this.cdr.markForCheck();
          return;
        })
        .catch((e) => {
          console.log('catch en pool: ' + e);
          this.cdr.markForCheck();
        });
    }

  private async setupFormConFechas(): Promise<void> {
    const rawModel = localStorage.getItem('tratamiento_temp')
      ? JSON.parse(localStorage.getItem('tratamiento_temp')!)
      : this.getModel();

    if (environment.appName === 'detorres') {
      const { dates, eventos } = await this.getEventosAPI();
      this.disabledDates = dates;

      this.form = new FertilizantesFormDefinition(
        this.getType(),
        rawModel,
        null,
        this.disabledDates,
        eventos,
      );
    } else {
      this.form = new FertilizantesFormDefinition(
        this.getType(),
        rawModel,
        null,
        [],
        [],
      );
    }

    this.form.model = this.model;

    this.initFormData();
    this.formRequest.executePhase(FormPhase.LOAD);
  }

    private parcelaLabel = (p: ParcelasModel) => {
      const nombre = (p.nombre ?? '').toString().trim();
      const variedad = (p.variedad ?? 'SIN VARIEDAD').toString().trim();

      let zonaRiegoAbrev = '';
      if ((p.cultivo ?? '').toLowerCase() === 'arroz') {
        const zr = (p.zona_riego ?? '').toString().toLowerCase();
        if (zr.includes('alta')) zonaRiegoAbrev = 'ZA';
        else if (zr.includes('baja')) zonaRiegoAbrev = 'ZB';
      }

      const variedadConZona = zonaRiegoAbrev
        ? `${variedad} - ${zonaRiegoAbrev}`
        : variedad;

      const pol = (p.poligono ?? '').toString().trim();
      const num = (p.numero ?? '').toString().trim();
      const rec = (p.recinto ?? '').toString().trim();
      const codigos = [pol, num, rec].filter(Boolean).join('-');

      const supRaw = (p.superficie_cultivada ?? p.superficie_sigpac ?? p.superficie ?? '0').toString();
      const supNum = parseFloat(supRaw.replace(',', '.')) || 0;
      const supFmt = supNum.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      const uds = this.form.env.textoSuperficie || 'ha';

      const derecha = [
        codigos || undefined,
        `${supFmt} ${uds}`
      ].filter(Boolean).join(' · ');

      return `${nombre} - ${variedadConZona} — ${derecha}`;
    };

    private expandFormRequest(): void {
      this.formRequest.addEvent(FormPhase.LOAD, EventPhase.AFTER, (resolve) => {
        localStorage.removeItem('tratamiento_temp');
        resolve(true);
      });
    }
}
